/**
 * Created by tmorone on 2/19/2016.
 */

/**
 * Called by the client to send events to Google Analytics
 * @param data
 */

var Marionette = require('backbone.marionette');
var App = require('../app.js');

module.exports = Marionette.Object.extend({

    initialize: function() {
        ga('create', 'UA-32592518-5', 'auto');
        ga('send', 'pageview');
    },

    trackEvent: function(data) {
        App.Logger.debug("Analytics Event: " + data.category + " " + data.action + " " + data.label);
        if(PR.environment !== 'local')
            ga('send', 'event', data.category, data.action, data.label, data.value);
    },

    pageView: function(data) {
        App.Logger.debug("Analytics Page View: " + data.page);
        if(PR.environment !== 'local')
            ga('send', 'pageview', data.page);
    },

    setPlayerID: function(data) {
        App.Logger.debug("Analytics Set Player ID: " + data.id);
        if(PR.environment !== 'local')
            ga('set', 'userId', data.id); // Resolve the GA session to the packrat ID
    }
});
